/* eslint-disable react/button-has-type */
import React from 'react';
import PropTypes from 'prop-types';

import './Button.scss';

const ArrowRightIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" width="20" height="20" className="button__arrow-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <line x1="5" y1="12" x2="19" y2="12" />
    <polyline points="12 5 19 12 12 19" />
  </svg>
);

const BackUndoIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    focusable="false"
    width="20"
    height="20"
    className="button__back-icon"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <line x1="19" y1="12" x2="5" y2="12" />
    <polyline points="12 19 5 12 12 5" />
  </svg>
);

const Button = ({
  title,
  type,
  secondary,
  tertiary,
  plain,
  withArrow,
  hideArrow,
  className,
  onClick,
  disabled,
  loading,
  hideLoadingText,
  testId,
}) => {
  if (!title) {
    return null;
  }

  const isBackButton = /^back$/i.test(title.trim());
  const isForwardArrowButton = withArrow || /^(next|skip)$/i.test(title.trim());
  const shouldShowArrow = !loading && isForwardArrowButton;
  const shouldRenderIcon = !loading && !plain && !hideArrow && (isBackButton || isForwardArrowButton);
  const shouldRenderLabel = !(loading && hideLoadingText);

  return (
    <button
      type={type}
      onClick={onClick}
      className={`button ${secondary ? 'button--secondary' : ''}
      ${tertiary ? 'button--tertiary' : ''}
      ${plain ? 'button--plain' : ''}
      ${shouldShowArrow ? 'button--with-arrow' : ''}
      ${loading ? 'button--loading' : ''}
      ${className}`}
      disabled={disabled}
      data-testid={testId}
    >
      {shouldRenderIcon && isBackButton && <BackUndoIcon />}
      {shouldRenderLabel && (
        <span className="button__label">{loading ? 'Saving...' : title}</span>
      )}
      {loading && <span className="button__spinner" aria-label="Loading" role="status" />}
      {shouldRenderIcon && !isBackButton && <ArrowRightIcon />}
    </button>
  );
};

Button.propTypes = {
  title: PropTypes.string,
  type: PropTypes.string,
  onClick: PropTypes.func,
  className: PropTypes.string,
  secondary: PropTypes.bool,
  tertiary: PropTypes.bool,
  plain: PropTypes.bool,
  withArrow: PropTypes.bool,
  hideArrow: PropTypes.bool,
  disabled: PropTypes.bool,
  loading: PropTypes.bool,
  hideLoadingText: PropTypes.bool,
  testId: PropTypes.string,
};

Button.defaultProps = {
  title: null,
  type: null,
  onClick: null,
  className: '',
  secondary: false,
  tertiary: false,
  plain: false,
  withArrow: false,
  hideArrow: false,
  disabled: false,
  loading: false,
  hideLoadingText: false,
  testId: null,
};

export default Button;
